import PropTypes from '@viking-eng/prop-types';
import { prepareHtml } from '@viking-eng/utils';
import React from 'react';
import Truncate from 'react-truncate';
import './Heading.css';

function Heading({ subTitle, subTitleTabIndex, title, titleTabIndex }) {
  return (
    <div className="heading">
      {title && (
        <div className="title" tabIndex={titleTabIndex} aria-label={title.toLowerCase()}>
          <Truncate lines={2}>
            <span dangerouslySetInnerHTML={prepareHtml(title)} />
          </Truncate>
        </div>
      )}

      {subTitle && (
        <div className="sub-title" dangerouslySetInnerHTML={prepareHtml(subTitle)} tabIndex={subTitleTabIndex} />
      )}
    </div>
  );
}

Heading.propTypes = {
  subTitle: PropTypes.string,
  subTitleTabIndex: PropTypes.number,
  title: PropTypes.string.isRequired,
  titleTabIndex: PropTypes.number
};

Heading.defaultProps = {
  subTitle: '',
  subTitleTabIndex: 0,
  titleTabIndex: 0
};

export default Heading;
